import { render, staticRenderFns } from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=template&id=646d58a8&"
import script from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=script&lang=js&"
export * from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('646d58a8')) {
      api.createRecord('646d58a8', component.options)
    } else {
      api.reload('646d58a8', component.options)
    }
    module.hot.accept("./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=template&id=646d58a8&", function () {
      api.rerender('646d58a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectOnHoldDeliverableTypeIcon.vue"
export default component.exports